var React = require('react');
var PropTypes = React.PropTypes;
var moment = require('moment');
// var Auth = require('../../resources/auth');
var request = require('superagent');
var env = require("../../utils/env");
var Helpers = require("../../utils/helpers");
var StudentClassRes = require("../../resources/studentclass");
var apiDomain = env.domain.api;
// import {Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn} from 'material-ui/Table';
import { Link } from 'react-router';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import CircularProgress from 'material-ui/CircularProgress';
import Checkbox from 'material-ui/Checkbox';
import RaisedButton from 'material-ui/RaisedButton';
import createConfirm from '../Modal/createConfirm';
import notification from '../Modal/notification';
import async from 'async';
import $ from 'jquery';
import '../../css/components/StudentClasses/StudentClasses.css';
import '../../css/components/StudentAnalytics/ViewStudentMistakesBank.css';

var MistakesBankTable = React.createClass({

    renderHeaderRows: function() {
        var result = [],
            _this = this;
        
        result.push(<th key={'studentClassName'} className="sortable mbHeader" onClick={this.changeSort.bind(this, 'studentClassName')}>
                Date
                </th>);
        result.push(<th key={'noOfStudents'} className="sortable mbHeader" onClick={this.changeSort.bind(this, 'noOfStudents')}>
                Concept
                </th>);
        result.push(<th key={'studentClassLevel'} className="sortable mbHeader" onClick={this.changeSort.bind(this, 'studentClassLevel')}>
                Wrong questions
                </th>);
        result.push(<th key={'dateCreated'} className="sortable mbHeader" onClick={this.changeSort.bind(this, 'dateCreated')}>
                Review
                </th>);
        // result.push(<th key={'phone'} className="sortable" onClick={this.changeSort.bind(this, 'phone')}>
        //         Phone
        //         {/*{this.getSortIcon('phone')}*/}
        //         </th>);
        // result.push(<th key={'lastActivityDate'} className="sortable" onClick={this.changeSort.bind(this, 'lastActivityDate')}>
        //         Last Activity Date
        //         {this.getSortIcon('lastActivityDate')}
        //         </th>);

        // for (var i = 0; i < types.length; i++) {
        //     var type = types[i];
        //     switch(type) {
        //     case 'title':
        //         result.push(<th key={type} className="sortable" onClick={this.changeSort.bind(this, 'title')}>
        //         Title
        //         {this.getSortIcon('title')}
        //         </th>);
        //         break;
        //     case 'subject':
        //         result.push(<th key={type} className="sortable" onClick={this.changeSort.bind(this, 'metadata.subjectName')}>
        //         <span>
        //             Subject
        //             {this.getSortIcon('metadata.subjectName')}
        //         </span>
        //         </th>);
        //         break;
        //     case 'concept':
        //         result.push(<th key={type} className="sortable" onClick={this.changeSort.bind(this, 'metadata.conceptName')}>
        //         <span>
        //             Concept
        //             {this.getSortIcon('metadata.conceptName')}
        //         </span>
        //         </th>);
        //         break;
        //     case 'mcqStat':
        //         result.push(<th key={type}>MCQ</th>);
        //         break;
        //     case 'ssStat':
        //         result.push(<th key={type}>SS</th>);
        //         break;
        //     case 'lsStat':
        //         result.push(<th key={type}>LS</th>);
        //         break;
        //     case 'reviewer':
        //         result.push(<th key={type}>Reviewers</th>);
        //         break;
        //     case 'finishReview':
        //         result.push(<th key={type}>Finished Review</th>);
        //         break;
        //     case 'dateCreated':
        //         result.push(<th key={type} className="sortable" onClick={this.changeSort.bind(this, 'dateCreated')}>
        //         Date Created
        //         {this.getSortIcon('dateCreated')}
        //         </th>);
        //         break;
        //     case 'dateModified':
        //         result.push(<th key={type} className="sortable" onClick={this.changeSort.bind(this, 'dateModified')}>
        //         Date Updated
        //         {this.getSortIcon('dateModified')}
        //         </th>);
        //         break;
        //     case 'dateSubmitted':
        //         result.push(<th key={type} className="sortable" onClick={this.changeSort.bind(this, 'date_submitted')}>
        //         Date Submitted
        //         {this.getSortIcon('date_submitted')}
        //         </th>);
        //         break;
        //     case 'creator':
        //         result.push(<th key={type}>Creator</th>);
        //         break;
        //     case 'round':
        //         result.push(<th key={type} className="sortable" onClick={this.changeSort.bind(this, 'current_review_round')}>
        //         Round
        //         {this.getSortIcon('current_review_round')}
        //         </th>)
        //         break;
        //     case 'actions':
        //         result.push(<th key={type}>Actions</th>);
        //         break;
        //     default: break;
        //     }
        // }
        return (
            <tr>
            {
                result.map((value, index) => {
                return value
                })
            }
            </tr>
        )
    },
    
    renderDataRows: function(types, data) {//, conceptsMap) {
        var result = [],
            _this = this;
        for (var i = 0; i < types.length; i++) {
            var type = types[i];
            switch(type) {
                case 'date':
                    result.push(<td key={type}>
                        {data.date}
                    </td>);
                    break;
                case 'concept':
                    result.push(<td key={type}>
                        {data.concept}
                    </td>);
                    break;
                case 'wrongQuestions':
                    result.push(<td key={type}>
                        {data.wrongQuestions}
                    </td>);
                    break;
                case 'review':
                    result.push(<td key={type}>
                        {data.review}
                    </td>);
                    break;
                // case 'phone':
                //     result.push(<td key={type}>
                //         {data.phone}
                //     </td>);
                //     break;
                // case 'lastActivityDate':
                //     result.push(<td key={type}>
                //         {data.lastActivityDate}
                //     </td>);
                //     break;
                default: break;
            }
        }

        return (
            <tr key={data._id}>
            {
              result.map((data, index) => {
                return data;
              })
            }
            </tr>
        )
    },

    showStudentClass: function(studentClassID) {
        
        this.props.showStudentClass(studentClassID);
    },

    editStudentClass: function(studentClassID) {

        this.props.editStudentClass(studentClassID);
    },

    getSortIcon: function(currentSort) {

        var ascSortIcon = <span className="fa fa-caret-up padding-left-5"></span>,
        descSortIcon = <span className="fa fa-caret-down padding-left-5"></span>,
        sortIcon = <span className="fa fa-sort padding-left-5"></span>,
        sort = this.state.sort;

        if (sort.indexOf(currentSort) >= 0) {
            
            if (sort.charAt(0) === '-') return descSortIcon;
            else return ascSortIcon;
        
        } else {
        
            return sortIcon;
        }
    },

    changeSort: function(chosenSort) {

        var newSort;
        if (this.state.sort.indexOf(chosenSort) >= 0) {
            var sort = this.state.sort;
            
            if (sort.charAt(0) === '-') newSort = sort.substr(1, sort.length);
            else newSort = '-'  + sort;
        
        } else {

            newSort = '-' + chosenSort;
        }

        if (this.props.onSortChange && typeof this.props.onSortChange === 'function') {
            this.props.onSortChange(newSort);
        }
    },

    getInitialState: function() {
        return {
            data: this.props.data,
            // conceptsMap: this.props.conceptsMap,
            // isOpenAssignDialog: false,
            // listReviewers: [],
            // isLoadingReviewers: false,
            // isAssigning: false,
            // assignedCollection: null,
            // assignedReviewers: [],
            // removedReviewers: [],
            mode: this.props.mode,
            sort: this.props.sort
        };
    },
    
    componentWillReceiveProps: function(nextProps) {
        this.setState({
          data: nextProps.data || this.state.data,
        //   conceptsMap: nextProps.conceptsMap || this.state.conceptsMap,
        //   mode: nextProps.mode || this.state.mode,
        //   sort: nextProps.sort || this.state.sort
        })
    },

    render: function() {
        var _this = this;
        // const actions = [
        //     <FlatButton
        //         label="Cancel"
        //         primary={true}
        //         onTouchTap={this.closeAssignTaskModal}
        //     />,
        //     <RaisedButton
        //         label={this.state.assignType === 'assign' ? "Assign" : "Re-assign"}
        //         primary={true}
        //         onClick={this.doAssign}/>
        // ];
        return (
            <div className="collection-table mbTable">
                
                <table className="table table-bordered table-striped">
                    <thead>
                    {
                        _this.renderHeaderRows()//(this.state.mode.cols)
                    }
                    </thead>
                    <tbody>
                        {
                            _this.state.data.map(function(data, index) {
                                {/*if (_this.state.mode.value.indexOf(data.status) < 0) return null;*/}
                                return (
                                    _this.renderDataRows(_this.state.mode.cols, data) //_this.state.conceptsMap)
                                )
                            })
                        }
                    </tbody>
                </table>
            </div>
        );
    },

    componentDidMount: function() {

    }
});

module.exports = MistakesBankTable;




/** WEBPACK FOOTER **
 ** ./src/components/StudentAnalytics/MistakesBankTable.js
 **/